import clsx from "clsx";
import Image from "next/image";

interface IllustrationProps {
	src: string;
	alt?: string;
	title: string;
	className?: string;
}

const Illustration = ({
	src,
	alt = `Illustration`,
	title,
	className,
}: IllustrationProps) => {
	return (
		<div className={clsx(`flex flex-col items-center`, className)}>
			<div className="relative h-40 w-full sm:h-48">
				<Image src={src} layout="fill" alt={alt} />
			</div>

			<p className="text-center font-semibold text-2xl text-slate-700">
				{title}
			</p>
		</div>
	);
};

export default Illustration;
